
/**
 * Bug Task
 * https://developerx.atlassian.net/browse/CS-5177
 * https://developerx.atlassian.net/browse/CS-5178
 * https://developerx.atlassian.net/browse/CS-5180
 *
 * Date Created : 06 Dec 2021       Created by   : Risman Abdilah
 * Date Updated : 06 Dec 2021       Updated by   : Risman Abdilah
 *
 * Version 1.0.0
 */

import $ from "jquery";
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";

import { CandidateAssessmentModel, CandidateModel } from "@/models/candidate.model";

import Badge from "@/components/properties/Badge.vue";
import { ASSESSMENT_TYPE } from "@/constants/enum.constant";
import ModalDetailAssessment from "@/components/candidate/ModalDetailAssessment.vue";

@Component({
  filters,
  components: {
    ModalDetailAssessment,
    Badge,
  },
})
export default class CandidateDetail extends Vue {
  /* VUEX */

  // ACTIONS
  @Action("actionSelectCandidateById", { namespace: "candidate" })
  private actionSelectCandidateById: any;
  @Action("actionSelectCandidateAssessmentResults", { namespace: "candidate" })
  private actionSelectCandidateAssessmentResults: any;

  // STATE
  @State("candidate", { namespace: "candidate" })
  private candidate: CandidateModel;
  @State("assessment_results", { namespace: "candidate" })
  private assessment_results: Array<CandidateAssessmentModel>;
  @State("school", { namespace: "academy" })
  private school: any;
  @State("locale")
  private locale: any;

  /* INITIALIZATION */
  private showContent: boolean = false;
  private showDetailAssessment: boolean = false;
  private activeSection = "profile";
  private currentShowAssessmentResult = {};

  constructor() {
    super();
  }

  private created() {
    this.actionSelectCandidateById(this.$route.params.id);
    this.actionSelectCandidateAssessmentResults(this.$route.params.id);

    this.listenContainerWidth();
    window.onresize = () => {
      this.listenContainerWidth();
    };
  }

  /* LIFECYCLE */

  private mounted() {
    // this.actionSelectCandidateById(this.$route.params.id);
    $(document).ready(function () {
      // Bind to scroll
      $(window).scroll(function () {
        var scrollPos: any = $(document).scrollTop();
        $(".candidateInfo").each(function () {
          var currLink = $('[data="' + $(this).attr("id") + '"]');
          var height: any = $(this).height();

          if (
            $(this).position().top <= scrollPos &&
            $(this).position().top + height + 100 > scrollPos
          ) {
            $("#menu ul li").removeClass("active");

            currLink.parent().addClass("active");
          } else {
            // currLink.parent().removeClass("active");
          }
        });
      });
    });
  }

  /* METHODS */
  private listenContainerWidth() {
    const cardProfile = ($("section#cardProfile").width() as number) + 70;
    const containerMain = $("div#containerMain").width() as number;
    const wallWidth = containerMain - cardProfile;
    $("#containerCandidateDetail").css("max-width", `${wallWidth}px`);
  }

  private clickEdit() {
    this.$router.push({
      name: "candidateDetailEdit",
      params: { id: this.candidate.user.id.toString() },
    });
  }

  private getMajor(item: any): string {
    if (!item) {
      return "";
    }
    if (this.locale == "id") {
      return item["translation"];
    }
    return item["major"];
  }

  private getDegree(item: any): string {
    if (!item) {
      return "";
    }
    if (this.locale == "id") {
      return item["translation"];
    }
    return item["degree"];
  }

  private getLanguage(item: any): string {
    if (!item) {
      return "";
    }
    if (this.locale == "id") {
      return item["translation"];
    }
    return item["language"];
  }

  private scrollTo(section: string) {
    var offset = ($(`#${section}`) as any).offset();
    var winHeight = $("#main-section").height();
    const headerHeight: any = $("#headerPersonal").height();
    $("html, body").animate(
      {
        scrollTop: offset.top - headerHeight - 150,
      },
      500
    );
    this.activeSection = section;
  }

  getAssessmentType (type) {
    return ASSESSMENT_TYPE.filter((v) => v.type === type)[0]
  }
  getAssessmentImageType (type) {
    const selType = ASSESSMENT_TYPE.filter((a) => a.type === type)
    if (selType.length > 0) {
      return selType[0].card_img
    }
  }
  private getAssessmentResults (jobId, appliedId, id) {
    //
  }
  private getAssessmentName(item: any): string {
    if (!item) {
      return "";
    }
    if (this.locale == "id") {
      return item["translation"];
    }
    return item["name"];
  }
  private getAssessmentColor (name) {
    if (name.toLowerCase() === 'strategic thinking') {
      return '#FBB03B'
    } else if (name.toLowerCase() === 'attention to detail') {
      return '#39B44A'
    } else if (name.toLowerCase() === 'career satisfaction') {
      return '#7AB8EB'
    } else if (name.toLowerCase() === 'analytical thinking') {
      return '#DA4CB2'
    } else if (name.toLowerCase() === 'intelligence test') {
      return '#3CB9B1'
    }
  }
}
